export default __webpack_public_path__ + "static/media/IMG_9939.693c67d4.jpeg";